import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkRating } from 'uitk-react-rating';

interface StarsProps {
  stars?: number;
}

export const Stars: React.FunctionComponent<StarsProps> = () => {
  const l10n = useLocalization();
  const { star, starRatingIcon } = usePropertyListing();

  if (!star) {
    return null;
  }

  return (
    <div className="all-b-padding-half">
      <span className="is-visually-hidden">{l10n.formatText('hotels.searchResults.filtersDialog.starRating.label')}</span>
      <UitkRating icon={starRatingIcon === 'STAR' ? 'star' : 'alternate'} rating={String(star)} />
    </div>
  );
};
